import { defineAsyncComponent } from 'vue';
import Loder from "./Loader.vue";

export default defineAsyncComponent({
	loader: () => import('./ReportViewerComponent.vue'),
	loadingComponent: Loder
});

